import { render, staticRenderFns } from "./LogisticChartRow.vue?vue&type=template&id=7d287dd4&scoped=true"
import script from "./LogisticChartRow.vue?vue&type=script&lang=js"
export * from "./LogisticChartRow.vue?vue&type=script&lang=js"
import style0 from "./LogisticChartRow.vue?vue&type=style&index=0&id=7d287dd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d287dd4",
  null
  
)

export default component.exports